import styled from 'styled-components'
import { Button } from 'components/common'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 343px;
  margin: 0 auto;
  justify-content: center;
  height: 100%;
`

export const LinkdropLogo = styled.img`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 107px;
`
